import { Box, Input, Paper, TextField } from "@material-ui/core";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { FiSearch } from "react-icons/fi";
const SearchBar = ({ onSubmit, value }) => {
  const [searchItem, setsearchItem] = useState("");
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   onSubmit(searchItem);
  // };
  // const sendData = (e) => {
  //   e.preventDefault();
  //   if (e.key === "Enter") console.log("object");
  //   // console.log("running", searchItem);
  //   onChange(searchItem);
  // };
  // const getValue = (e) => {
  //   e.preventDefault();
  //   // console.log(searchItem);
  //   onChange(searchItem);
  //   // console.log("1", searchItem);
  //   // console.log(e.target.value);
  // };
  // console.log(searchItem);
  return (
    <div className="head">
      <img
        src="http://pngimg.com/uploads/youtube/youtube_PNG5.png"
        alt="YouTube Logo"
        className="youtube_logo"
      />

      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit(searchItem);
        }}
        className="search_bar"
      >
        <input
          className="search_input"
          type="text"
          placeholder="Search........."
          onChange={(event) => setsearchItem(event.target.value)}
          value={searchItem}
        />
        <button className="search_button">
          <FiSearch type="submit" className="search_logo" />
        </button>
      </form>
      {/* <form
        onSubmit={(e) => {
          e.preventDefault();
          onChange(searchItem);
          value(searchItem);
        }}
      >
        <input type="text" onSubmit={getValue} />
      </form> */}
    </div>
  );
};

export default SearchBar;

// <Paper elevation={6} style={{ padding: "25px" }}>
//   <Box display="flex">
//     <img
//       src="https://www.flaticon.com/svg/static/icons/svg/889/889241.svg"
//       alt=""
//     />
//     <form
//       style={{
//         marginLeft: "100px",
//         width: "100%",
//       }}
//     >
//       <Input
//         placeholder="Search ...."
//         inputProps={{ "aria-label": "description" }}
//         />
//       {/* <TextField
//         style={{ width: "100%" }}
//         label="Search..."
//         fullwidth
//       ></TextField> */}
//     </form>
//   </Box>
// </Paper>
